<template lang="pug">
v-expansion-panels(flat)
  v-expansion-panel
    v-expansion-panel-header.pr-2.pl-0.py-0(ripple)
      div
        v-icon.mr-4(
          size="34"
          color="secondary"
        ) mdi-bookshelf
        span.text-body-2: strong {{ name }}
    v-expansion-panel-content
      //- tooltip-wrap(text="Требуется подпись" color="warning")
      //-   v-icon(v-if="needToSign" size="22"  color="warning").ml-2 mdi-alert
      v-list.py-0
        v-list-item.pl-3.pr-2.py-2(
          v-if="showCreate"
          style="min-height: 0px !important;"
          @click="generateAct"
          link
        )
          v-list-item-action.mr-4.my-0
            v-icon(
              v-if="!actLoading"
              size="22"
              color="primary"
            ) mdi-text-box-plus-outline
            v-progress-circular(
              v-else
              indeterminate
              color="primary"
            )
          v-list-item-content.py-0
            .primary--text.text-body-2: strong Сформировать акт

        v-list-item.pl-3.pr-2.py-2(
          v-if="document"
          style="min-height: 0px !important;"
          target="_blank"
          :href="document.url"
        )
          v-list-item-action.mr-4.my-0: v-icon(
            size="22"
            color="primary"
          ) mdi-file-download
          v-list-item-content.py-0
            .primary--text.text-body-2: strong Документ
          v-list-item-action.ma-0
            v-icon(color="primary" size="16") mdi-download
        v-list-item.pl-3.pr-2.py-2(
          v-if="isSignedCustomer || isSignedExecutor"
          style="min-height: 0px !important;"
          :loading="loadingDocument"
          @click="getPrintVersion"
        )
          v-list-item-action.mr-4.ma-0: v-icon(
            size="22"
            color="info"
          ) mdi-printer-outline
          v-list-item-content.py-0
            .info--text.text-body-2 Печатная версия
          v-list-item-action.ma-0
            v-icon(color="primary" size="16") mdi-download

        template(v-if="!loading")
          v-list-item.pl-3.pr-2.py-2(
            v-for="(sign, idx) in Object.values(signs).reverse()"
            v-if="sign.val"
            :key="idx"
            style="min-height: 0px !important;"
            @click="getSignature(sign.id)"
          )
            v-list-item-icon.mr-4.ma-0: v-icon(
              size="22"
              color="secondary"
            ) mdi-file-sign
            v-list-item-content.py-0
              .secondary--text.text-body-2 {{ sign.text }}
            v-list-item-action.ma-0
              v-icon(color="primary" size="16") mdi-download

          v-alert.mt-1.mb-0(
            v-if="(isCustomerSignFirst ? !isSignedCustomer : !isSignedExecutor) && document"
            outlined
            :color="isEnrollment ? 'warning' : 'info'" text
          )
            span {{signText}}

      .d-flex
        v-btn.ml-auto.mt-2.px-4(
          v-if="needToSign && document"
          small
          color="primary" outlined
          @click="openFileSign"
        )
          v-icon(size="" left) mdi-draw-pen
          span Подписать

  portal(to="sign.dialog" v-slot="{ close, attrs }")
    v-card.sdo-card(v-if="needToSign")
      v-card-title Подпись договора
      v-card-text
        file-sign.mt-4(
          :files="contractDocument"
          :successCallback="signDocument"
        )
</template>
<script>
import { getFileFromUrl } from '@/utils/base64';
import FileSign from '@/components/FileSignature/index.vue';

const SIGNS = {
  oneSign: 1,
  allSign: 2,
};
const SIGN_ICONS = {
  [SIGNS.oneSign]: { icon: 'mdi-check', color: 'success lighten-1', text: 'подписан одной из сторон' },
  [SIGNS.allSign]: { icon: 'mdi-check-all', color: 'success', text: 'подписан обеими сторонами' },
};

export default {
  components: { FileSign },
  props: {
    contract: { type: Object, required: true },
    document: { type: Object, default: () => {} },
    name: { type: String, required: true },
    noPrint: { type: Boolean, default: false },
    isSignedCustomer: { type: Boolean, default: false },
    isSignedExecutor: { type: Boolean, default: false },
    isCustomerSignFirst: { type: Boolean, default: false },
    signKey: { type: String, default: '' },
    signMethod: { type: Function, required: true },
    getSignMethod: { type: Function, required: true },
    getPrintMethod: { type: Function, required: true },
    isEnrollment: { type: Boolean, required: true },
    showCreate: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      actLoading: false,
      loadingDocument: false,
      signs: {
        customer: {
          text: 'Подпись заказчика',
          val: this.isSignedCustomer,
        },
        executor: {
          text: 'Подпись исполнителя',
          val: this.isSignedExecutor,
        },
      },
    };
  },
  computed: {
    signText() {
      const check = this.isCustomerSignFirst ? this.isEnrollment : !this.isEnrollment;
      return check ? 'Вы еще не подписали' : 'Заказчик еще не подписал';
    },
    signsLength() {
      return Object.values(this.signs).filter(({ id }) => id).length;
    },
    signIcon() {
      return SIGN_ICONS[this.signsLength];
    },
    needToSign() {
      const { isSignedCustomer: customer, isSignedExecutor: executor, isCustomerSignFirst } = this;
      let checkedValue;
      if (isCustomerSignFirst) {
        checkedValue = this.isEnrollment
          ? !customer : (customer && !executor);
      } else {
        checkedValue = !this.isEnrollment
          ? !executor : !customer;
      }
      return checkedValue;
    },
    contractDocument() {
      const { url, original_name: originalName } = this?.document || { };
      return this?.document ? [{ url, originalName }] : null;
    },
  },
  created() {
    const { isSignedCustomer: customer, isSignedExecutor: executor } = this;
    if ((customer || executor)) {
      this.loading = true;
      this.getSignDocuments();
    }
  },
  methods: {
    async generateAct() {
      this.actLoading = true;
      await this.$api.contracts.generateAct(this.contract.id);
      this.actLoading = false;
      this.$emit('update');
    },
    openFileSign() {
      this.$modals.show('dialog-portal', {
        inputValue: 'sign',
      });
    },
    async getPrintVersion() {
      this.loadingDocument = true;
      await this.getPrintMethod(this.contract.id).then((data) => {
        const blob = new Blob([data.data], { type: 'application/pdf' });
        const objectUrl = URL.createObjectURL(blob);
        window.open(objectUrl);
      });
      this.loadingDocument = false;
    },
    async getSignatureFile(signature, filename = 'signature.sig') {
      const link = document.createElement('a');
      const file = await getFileFromUrl(`data:application/octet-stream;base64,${signature}`, filename);
      link.href = URL.createObjectURL(file);
      link.download = `${filename}`;
      link.click();
    },
    async getSignDocuments() {
      const { data } = await this.getSignMethod(this.contract.id);
      data.data.forEach((sign) => {
        if (sign.owner_id === this.contract.owner_id) {
          this.signs.customer = { ...this.signs.customer, ...sign };
        } else this.signs.executor = { ...this.signs.executor, ...sign };
      });
      this.loading = false;
      this.$modals.close();
    },
    async getSignature(id) {
      const { data } = await this.$api.contracts.getSignature(this.contract.id, id);
      this.getSignatureFile(data);
    },
    async signDocument([value]) {
      await value.validate();
      const {
        hash,
        signature,
        signData: {
          commonName, serialNumber, validFromDate, validToDate, issuerName, title,
        },
      } = value;
      const payload = {
        hash,
        position: title,
        sign_hash: signature,
        common_name: commonName,
        issuer_name: issuerName,
        serial_number: serialNumber,
        valid_from_at: validFromDate,
        valid_to_at: validToDate,
      };
      const newContract = { ...this.item };
      await this.$rHandler(
        this.signMethod(this.contract.id, payload),
        () => {
          const key = this.isEnrollment ? `is_signed_customer${this.signKey}` : `is_signed_executor${this.signKey}`;
          newContract[key] = true;
        },
      );
      this.$emit('set', newContract);
      this.getSignDocuments();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-expansion-panel-header {
  min-height: 56px !important;
}
::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
